import { z } from "zod";
import { playbookStatusSchema } from "./playbook";

export const playbookStatusTransitionReasonSchema = z.enum(["BUDGET", "MANUAL", "ENDED", "METRICS"]);
export type PlaybookStatusTransitionReason = z.infer<typeof playbookStatusTransitionReasonSchema>;

export const playbookStatusTransitionSchema = z.object({
  id: z.string().uuid(),
  playbookId: z.string().uuid(),
  from: playbookStatusSchema,
  to: playbookStatusSchema,
  reason: playbookStatusTransitionReasonSchema.nullable(),
  userId: z.string().uuid().nullable(),
  createdAt: z.date(),
});

export type PlaybookStatusTransition = z.infer<typeof playbookStatusTransitionSchema>;

export const createPlaybookStatusTransitionSchema = z.object({
  playbookId: z.string().uuid(),
  from: playbookStatusSchema,
  to: playbookStatusSchema,
  reason: playbookStatusTransitionReasonSchema.nullish(),
  userId: z.string().uuid().nullish(),
});

export type CreatePlaybookStatusTransition = z.infer<typeof createPlaybookStatusTransitionSchema>;
